export const pointsDetailsTitleStyle = {
  margin: 0,
  fontSize: "24px",
  fontWeight: 600,
  lineHeight: "1.25",
  fontFamily: "Montserrat, sans-serif",
  fontStyle: "normal",
  color: "#192F67",
  marginBottom: "0.35em"
};

export const pointsDetailsSubtitleStyle = {
  margin: 0,
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "150%",
  fontFamily: "Montserrat, sans-serif",
  fontStyle: "normal",
  letterSpacing: "0.15px",
  color: "rgba(0, 0, 0, 0.60)"
};
